import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProfileRedirect() {
  const { user } = useAuth();
  if (!user) return null;
  return <Navigate to={`/members/${user.id}`} replace />;
}
